import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    loading: 'idle',
    error: null,
    entities: []
};
export var MenuItemsActionType;
(function (MenuItemsActionType) {
    MenuItemsActionType["FetchMenuItems"] = "menuItems/fetchMenuItems";
})(MenuItemsActionType || (MenuItemsActionType = {}));
export const fetchMenuItems = createAsyncThunk(MenuItemsActionType.FetchMenuItems, (requestData, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        const menuItems = yield api.getMenuItems(requestData.revenueCenterId, requestData.serviceType);
        return menuItems;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const menuItemsSlice = createSlice({
    name: ReducerType.MenuItems,
    initialState,
    reducers: {
        resetMenuItems: () => initialState,
        setMenuItems: (state, action) => {
            state.entities = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchMenuItems.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchMenuItems.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchMenuItems.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetMenuItems, setMenuItems } = menuItemsSlice.actions;
export const selectMenuItems = (state) => state.menuItems;
export const menuItemsReducer = menuItemsSlice.reducer;
